import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { FieldValues, Control, useWatch } from 'react-hook-form';

import { CheckableFields } from '../CheckableFields';
import { InteractEligibilities } from './fields';

import style from './index.module.scss';

type Props = {
  control: Control<FieldValues, object>;
  disabled?: boolean;
  hiddenEligibilityFields?: string[];
};

export const EligibilitiesFields = ({ control, disabled, hiddenEligibilityFields }: Props) => {
  const { t } = useTranslation();

  const fields = useMemo(
    () =>
      InteractEligibilities.filter(i => !hiddenEligibilityFields?.includes(i?.name)).map(x => ({
        ...x,
        name: `permissions.${x.name}`,
      })),
    [hiddenEligibilityFields],
  );

  const eligibilities = useWatch({ control, name: 'permissions' });
  const eligibityCount = useMemo(
    () =>
      eligibilities
        ? Object.keys(eligibilities).filter(x => {
            const v = eligibilities[x];
            return Array.isArray(v) ? !!v[0] && !!v[1] : v;
          }).length
        : 0,
    [eligibilities],
  );

  return (
    <>
      <div className={style.formTitle}>
        {t('EligibilitiesFields.1f1r1rs')}
        <span className={style.eligibiTitle}>
          ({eligibityCount || t('EligibilitiesFields.1n92619')})
        </span>
      </div>
      <CheckableFields
        control={control}
        fields={fields}
        className={style.eligibiBody}
        disabled={disabled}
      />
    </>
  );
};
